import { useRef, useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { UploadCloud, CheckCircle2, Loader2, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * KycUpload — uploads a private KYC document (DL front/back, RC, insurance, etc).
 * Stored in Emergent Object Storage with `is_private=true`. Only the mate + admin
 * can view the raw file. Displays only a check + filename for the mate.
 */
export default function KycUpload({ kind, label, value, onChange, token, testid = "kyc-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 8 * 1024 * 1024) { toast.error("Max 8MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("kind", kind);
      const r = await axios.post(`${API}/upload/kyc-doc`, fd, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
      onChange(r.data.path);
      toast.success(`${label} uploaded — kept private`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally { setBusy(false); }
  };

  return (
    <div>
      <div className="text-[10px] uppercase text-neutral-500 mb-1 flex items-center gap-1">
        <Lock className="w-2.5 h-2.5" /> {label}
      </div>
      <input ref={ref} data-testid={`${testid}-input`} type="file" accept="image/*,application/pdf" className="hidden" onChange={upload} />
      <button type="button" data-testid={`${testid}-btn`} onClick={() => ref.current?.click()}
        className={`w-full flex items-center justify-center gap-2 rounded-xl border-2 border-dashed py-3 px-3 text-xs font-bold transition-colors ${
          value ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "border-black/15 bg-white text-neutral-600 hover:border-[color:var(--secondary)]"
        }`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" />
          : value ? <><CheckCircle2 className="w-4 h-4" /> Uploaded · tap to replace</>
          : <><UploadCloud className="w-4 h-4" /> Upload</>}
      </button>
    </div>
  );
}
